import PlaneAction from "./PlaneAction.js";
import {CONDITION_TYPES, setAirborn, setCondition, setPower} from "../planeSlice.js";

import {convertToMeters, getMaxWeight, getTORR, getTODR, getVr} from "../../assets/virtual-flyout/perf-calc.js";
import {getActiveRunway, getRunwayDistances} from "../../assets/virtual-flyout/airport-service.js";
import {getHeadTailWind, getRunwayHeading} from "../../assets/virtual-flyout/nav-calc.js";

export default class TakeOffRoll extends PlaneAction {
    constructor(planeId, airportWp, runway = null) {
        super(planeId);
        this.airportWp = airportWp;
        this.runway = runway;
        this.Vr = getVr();
    }

    execute() {
        const plane = this.getState();
        if (!this.runway) {
            const wind = plane.wind;
            const activeRunway = getActiveRunway(this.airportWp.code, wind.heading);
            this.runway = activeRunway.runway;
        }

        const runwayHeading = getRunwayHeading(this.runway);
        const headTailwind = getHeadTailWind(runwayHeading, plane.wind);

        const takeOffWeight = plane.weight.empty + plane.weight.fuel + plane.weight.payload;
        const mtow = getMaxWeight(plane.type);
        const {TORA, TODA} = getRunwayDistances(this.airportWp.code, this.runway);
        const TORR = getTORR(plane.type,plane.temperature,plane.altitude, takeOffWeight, headTailwind);
        const TODR = getTODR(plane.type,plane.temperature,plane.altitude, takeOffWeight, headTailwind);
        if (takeOffWeight > mtow) {
            this.dispatch(setCondition({condition: CONDITION_TYPES.MTOW_EXCEEDED}));
        } else if (convertToMeters(TORR) > TORA) {
            this.dispatch(setCondition({condition: CONDITION_TYPES.TORR_EXCEEDED}));
        } else if (convertToMeters(TODR) > TODA) {
            this.dispatch(setCondition({condition: CONDITION_TYPES.TODR_EXCEEDED}));
        } else {
            this.log(`Taking off`);
            this.dispatch(setPower({power: 100}));
        }
    }

    isComplete() {
        const tas = this.getState().tas;
        const airborn = tas >= this.Vr;
        this.dispatch(setAirborn({airborn}));
        return airborn;
    }
}